import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=a104fc02&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"
import style0 from "./performance.vue?vue&type=style&index=0&id=a104fc02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a104fc02",
  null
  
)

export default component.exports